import { render, staticRenderFns } from "./FarmerActions.vue?vue&type=template&id=3856a488&"
import script from "./FarmerActions.vue?vue&type=script&lang=js&"
export * from "./FarmerActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports